import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import Schema from './schema';
import View, { TestimonialData } from './View';

interface TestimonialsEditProps {
  data?: TestimonialData;
  block: string;
  selected: boolean;
  onChangeBlock: (block: string, data: Record<string, any>) => void;
}

const TestimonialsEdit = (props: TestimonialsEditProps) => {
  const { onChangeBlock, block, selected, data } = props;

  const schema = Schema(props);
  return (
    <>
      <View {...props} data={data} isEditMode />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          {...props}
          schema={schema}
          title={schema.title}
          formData={data}
          block={block}
          onChangeBlock={onChangeBlock}
          onChangeField={(id: any, value: any) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
        />
      </SidebarPortal>
    </>
  );
};

export default TestimonialsEdit;
